module.exports = __webpack_public_path__ + "static/media/cpg_desktop_unsafecars_banner.77dec58d.png";